import axios from '../../../axios';
import IBulkEmail from '../types/IBulkEmail';
import IEmailReplace from '../types/IEmailReplaceDTO';

const url = '/candidatesearch/api/bulk-email-scheduling/';
const candidateSearch = '/candidatesearch/api/';

export const sendBulkEmail = (data: IBulkEmail) => axios.post(`${url}throttle`, data);

export const sendBulkEmailCandidateProfiles = (data: IBulkEmail) =>
  axios.post(`${candidateSearch}email-log/bulk-email-candidate-profiles`, data);

export const getRecruiterSMTPAccounts = () => axios.get('/emailingapp/api/recruiter-smtp-accounts');

export const replacePlaceHolders = (data: IBulkEmail) =>
  axios.post(`${candidateSearch}email-log/replace-placeholders`, data);

export const replaceCandidateEmail = (payload: IEmailReplace) =>
  axios.post('/candidatesearch/api/candidate/update-contact-link', payload);

export const addCandidateEmail = (payload: IEmailReplace) =>
  axios.post('/candidatesearch/api/candidate/add-contact-link', payload);

export const markEmailAsPrimary = (payload: IEmailReplace) =>
  axios.post('/candidatesearch/api/candidate/mark-email-primary', payload);

export const validateEmails = (to: string[], cc: string[], bcc: string[]) =>
  axios.post('/emailingapp/api/emailing/validate-emails', { to, cc, bcc });

export const getSMTPAccountsByRecruiter = (recruiterId: string) =>
  axios.get('/emailingapp/api/recruiter-smtp-accounts', { params: { recruiterId } });

export const getEmailActivityLog = (id: string) => axios.get(`${candidateSearch}email-log/${id}`);

export const getAccountManagerTemplate = (templateName: string, workspaceId: string) =>
  axios.get(
    `${candidateSearch}candidate-fields-submission-settings?templateName=${templateName}&workspaceId=${workspaceId}`
  );
